import React from 'react';
import ColorRGBControl from '../ColorRGBControl';
import { actuatorControlPropTypes } from '../../types';

const controlComponents = {
  color: ColorRGBControl,
};

const CompositeControl = props => {
  const { feature } = props;
  const ControlStrategy = controlComponents[feature.property];
  if (!ControlStrategy) return null;

  return <ControlStrategy {...props} />;
};

CompositeControl.propTypes = actuatorControlPropTypes;

export default CompositeControl;
